import { Dispatch, SetStateAction, useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationQuestionsKey,
  errorMessage,
  SubmitQuestion,
  updateJobPostingsQuestionsRoute,
} from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';
import { authContext, profileKey } from '@staffedupusa/shared-components';
import { updateWalkthroughStatus } from '@utils/updateOnboardingStatus';
import { useUpdateStatus } from '@features/profile/hooks/useUpdateStatus';

type UseUpdateApplicationQuestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateApplicationQuestion = ({
  setErrorText = () => {},
}: UseUpdateApplicationQuestionProps) => {
  const client = useQueryClient();
  const { authData } = useContext(authContext);
  const { updateStatus } = useUpdateStatus({});
  const {
    mutate: updateApplicationQuestion,
    isLoading: isUpdateApplicationQuestionLoading,
  } = useMutation({
    mutationFn: (variables: SubmitQuestion) =>
      axiosInstance
        .post(updateJobPostingsQuestionsRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        client.invalidateQueries([applicationQuestionsKey]);
        client.invalidateQueries([profileKey]);
        if (data.user) {
          updateWalkthroughStatus(
            data.user?.company?.plan,
            data.user,
            undefined,
            updateStatus,
          );
        }
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { updateApplicationQuestion, isUpdateApplicationQuestionLoading };
};
